import { createSlice } from '@reduxjs/toolkit';

const shiftSlice = createSlice({
  name: 'shift',
  initialState: localStorage.getItem('shift') || 'first',
  reducers: {
    setShift: (state, action) => {
      try {
        localStorage.setItem('shift', action.payload);
      } catch {
        console.error('Failed to save shift to localStorage');
      }
      return action.payload;
    },
  },
});

export const { setShift } = shiftSlice.actions;
export default shiftSlice.reducer;
